import { fieldTypes } from '@actions/conference';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker } from '@atoms';
import messages from './messages';

export default class TimeManager extends PureComponent {
  static propTypes = {
    date: PropTypes.string.isRequired,
    setField: PropTypes.func.isRequired,
  };

  handleDateChange = (value) => {
    const newDate = moment(value).format('YYYY-MM-DDTHH:mm:ssZ');
    this.props.setField(fieldTypes.DATE, newDate);
  };

  render() {
    const { date } = this.props;
    return (
      <DatePicker
        id="conference-date"
        caption={<FormattedMessage {...messages.Date} />}
        value={new Date(date)}
        onChange={this.handleDateChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/molecules/TimeManager/TimeManager.js